import React from 'react';
import { isToday, isWithinInterval, parseISO } from 'date-fns';
import EventIcon from '@mui/icons-material/Event';
import VisitorsList from './VisitorsList';

const TodayVisitors: React.FC = () => {
  // Filter function for today's visitors
  const filterTodayVisitors = (invite: any) => {
    // For single-day invites
    if (!invite.isMultiDay && invite.visitDateTime) {
      const visitDate = parseISO(invite.visitDateTime);
      return isToday(visitDate);
    }
    
    // For multi-day invites
    if (invite.isMultiDay && invite.startDate && invite.endDate) {
      const startDate = parseISO(invite.startDate);
      const endDate = parseISO(invite.endDate);
      const now = new Date();
      
      return isWithinInterval(now, {
        start: new Date(startDate.setHours(0, 0, 0, 0)),
        end: new Date(endDate.setHours(23, 59, 59, 999)),
      });
    }
    
    return false;
  };

  return (
    <VisitorsList
      title="Today's Booked Visitors"
      icon={<EventIcon sx={{ color: '#345678' }} />}
      filterFunction={filterTodayVisitors}
      emptyMessage="No visitors booked for today."
      showBadge={false}
    />
  );
};

export default TodayVisitors;